// extracted by mini-css-extract-plugin
export default {"root":"IconDelete_root__-HsLA"};